"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IdleSessionTimeout_1 = require("./services/IdleSessionTimeout");
exports.IdleSessionTimeout = IdleSessionTimeout_1.IdleSessionTimeout;
//# sourceMappingURL=index.js.map